__turbopack_context__.v({
  "academicTheme": "calendar-module__QcE3RG__academicTheme",
  "calendarBodyGrid": "calendar-module__QcE3RG__calendarBodyGrid",
  "calendarContainer": "calendar-module__QcE3RG__calendarContainer",
  "closeModalBtn": "calendar-module__QcE3RG__closeModalBtn",
  "controlsGroup": "calendar-module__QcE3RG__controlsGroup",
  "dayCell": "calendar-module__QcE3RG__dayCell",
  "dayCellOtherMonth": "calendar-module__QcE3RG__dayCellOtherMonth",
  "dayCellToday": "calendar-module__QcE3RG__dayCellToday",
  "dayContent": "calendar-module__QcE3RG__dayContent",
  "dayNumber": "calendar-module__QcE3RG__dayNumber",
  "dayOfWeek": "calendar-module__QcE3RG__dayOfWeek",
  "daysOfWeekGrid": "calendar-module__QcE3RG__daysOfWeekGrid",
  "desktopHoverCard": "calendar-module__QcE3RG__desktopHoverCard",
  "detailButton": "calendar-module__QcE3RG__detailButton",
  "dot": "calendar-module__QcE3RG__dot",
  "eventDotIndicator": "calendar-module__QcE3RG__eventDotIndicator",
  "fadeInCenter": "calendar-module__QcE3RG__fadeInCenter",
  "fadeInLeftEdge": "calendar-module__QcE3RG__fadeInLeftEdge",
  "fadeInRightEdge": "calendar-module__QcE3RG__fadeInRightEdge",
  "header": "calendar-module__QcE3RG__header",
  "hoverOverlayWrapper": "calendar-module__QcE3RG__hoverOverlayWrapper",
  "legend": "calendar-module__QcE3RG__legend",
  "legendItem": "calendar-module__QcE3RG__legendItem",
  "mobileModalBackdrop": "calendar-module__QcE3RG__mobileModalBackdrop",
  "mobileModalContent": "calendar-module__QcE3RG__mobileModalContent",
  "monthNav": "calendar-module__QcE3RG__monthNav",
  "monthTitle": "calendar-module__QcE3RG__monthTitle",
  "navButton": "calendar-module__QcE3RG__navButton",
  "overlayCenter": "calendar-module__QcE3RG__overlayCenter",
  "overlayContainer": "calendar-module__QcE3RG__overlayContainer",
  "overlayDetails": "calendar-module__QcE3RG__overlayDetails",
  "overlayLeftEdge": "calendar-module__QcE3RG__overlayLeftEdge",
  "overlayRightEdge": "calendar-module__QcE3RG__overlayRightEdge",
  "overlayTitle": "calendar-module__QcE3RG__overlayTitle",
  "socialTheme": "calendar-module__QcE3RG__socialTheme",
  "sportTheme": "calendar-module__QcE3RG__sportTheme",
  "todayButton": "calendar-module__QcE3RG__todayButton",
  "womensEventTheme": "calendar-module__QcE3RG__womensEventTheme",
});
